import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyGinIssueMoveRoute: InvariantJiraRoute = {
	name: 'legacy-gin-issue-move',
	path: '/secure/MoveIssue(\\w*)([!%]?[\\w]*).jspa',
};
